import { Component, OnInit } from '@angular/core';
import { appConfig } from '../app.config';
import * as XLSX from 'xlsx';
import { BackendApiService } from '../services/backend-api.service';
import { BaseUrlConstantsService } from '../services/base-url-constants.service';
import { Router, ActivatedRoute } from '@angular/router';
import { ChangeUsersService } from '../services/change-users.service';
import { ConvertDatetimePipe } from '../convert-datetime.pipe';
import { Location } from '@angular/common';


@Component({
  selector: 'app-em-configurator-mapping',
  templateUrl: './em-configurator-mapping.component.html',
  styleUrls: ['./em-configurator-mapping.component.scss']
})
export class EmConfiguratorMappingComponent implements OnInit {

  data: any[] = [];
  headers: string[] = [];
  columnOptions = appConfig.columnOptions;
  //selectedColumn: string = '';
  public deviceConnectionRange: number[] = [];

    deviceCategoryId: number | null = null;
  deviceId: number | null = null;
  modbusDeviceNo: number | null = null;
  public formTitle:String='Addform';
  public editObj: any[] = [];
  isLoading: boolean = true;

  public today: Date;

  private EnergymeterBaseUrl = BaseUrlConstantsService.energyMeterApi;

  constructor(
    public router: Router,
    private dataService: BackendApiService, 
    private route: ActivatedRoute,
    private changeService: ChangeUsersService,
    private location: Location
  ) { 

    this.utcTime();
  }

  utcTime() {
    setInterval(() => {
      this.today = new ConvertDatetimePipe().convertDateTime(new Date());
    }, 1000);
  }

  ngOnInit(): void {

    // Get query parameters
    this.route.queryParams.subscribe(params => {
      this.deviceCategoryId = params['deviceCategoryId'] || null;
      this.deviceId = params['deviceId'] || null;
      this.modbusDeviceNo = params['modbusDeviceNo'] || null;
    });

    const startingNumber = Number(this.modbusDeviceNo);

    // Generate an array of 5 consecutive numbers
    this.deviceConnectionRange = Array.from({ length: 5 }, (_, i) => startingNumber + i);

    //Check existing data into device_modbus_mapping table by device_type_id.
    // Add Case/ Edit Case.

    

    this.dataService.getDataWithQuery(this.EnergymeterBaseUrl+"/get-deviceModbusMapping-by-devicetypeid/"+this.deviceId)
      .then(res => {

        this.isLoading=false;

        if (JSON.parse(JSON.stringify(res)).data.status === 'error' && JSON.parse(JSON.stringify(res)).data.code === 400) {
          
          this.editObj = [];
          this.formTitle = "Addform";

        } else if (JSON.parse(JSON.stringify(res)).data.status === 'success' && JSON.parse(JSON.stringify(res)).data.code === 200) {

          this.editObj = JSON.parse(JSON.stringify(res)).data.body;

          if(this.editObj.length >0){
            this.formTitle = "Editform";

          }else{
            this.formTitle = "Addform";
          }

        } else {
          this.dataService.showError('Something went wrong.');
        }

      });

  }

  addRow() {
    const newRow = {
      Start: '',
      End: '',
      Description: '',
      colName: this.columnOptions[0],
      deviceCategoryId:'',
      modbusNumber: this.deviceConnectionRange[0],
      serialNo: this.editObj.length + 1,
      deviceId: '',
      //selected: false
    };
    this.editObj.push(newRow);
  }

  // Delete a row at a specific index
  deleteRow(index: number, deviceModbusMapping_id) {
    this.editObj.splice(index, 1);

    // After deletion, update the serial numbers
    this.updateSerialNumbers();

    //Delete Enerticsmaster.device_modbus_mapping records delete by id.
    this.dataService.postData(this.EnergymeterBaseUrl+"/device-modbus-mapping-delete/"+deviceModbusMapping_id,{})
      .then(res => {

        this.isLoading=false;

        if (JSON.parse(JSON.stringify(res)).data.status === 'error' && JSON.parse(JSON.stringify(res)).data.code === 400) {
          
          this.dataService.showError(JSON.parse(JSON.stringify(res)).data.message);

        } else if (JSON.parse(JSON.stringify(res)).data.status === 'success' && JSON.parse(JSON.stringify(res)).data.code === 200) {       
          
          this.dataService.showSuccess(JSON.parse(JSON.stringify(res)).data.message);
        } else {
          this.dataService.showError('Something went wrong.');
        }

      });

  }

  updateSerialNumbers() {
    this.editObj.forEach((row, index) => {
      row.serialNo = index + 1; // Recalculate serial numbers
    });
  }
  
  onFileChange(event: any) {

    const file = event.target.files[0];
    if (file.type !== 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
      throw new Error('Invalid file type. Please upload an Excel file.');
    }


    const target: DataTransfer = <DataTransfer>(event.target);
  
    if (target.files.length !== 1) {
      throw new Error('Cannot use multiple files');
    }else{
    }
  
    const reader: FileReader = new FileReader();
  
    reader.onload = (e: any) => {
      const binaryString: string = e.target.result;
      const workbook: XLSX.WorkBook = XLSX.read(binaryString, { type: 'binary' });
      const sheetName: string = workbook.SheetNames[0];
      const sheet: XLSX.WorkSheet = workbook.Sheets[sheetName];
      
      // Parse the data (header: 1 means the first row is considered headers)
      const rawData: any[][] = XLSX.utils.sheet_to_json(sheet, { header: 1 });

      // Extract headers from the second row (index 1)
      this.headers = rawData[1] as string[];
  
      // Extract data from rows starting after the header row
      this.data = rawData.slice(2) // Skip header and any empty rows before data
        .filter((row: any[]) => row.some(cell => cell !== null && cell !== '')) // Remove empty rows
        .map((row: any[], index: number) => { // Add index as the second argument
          const rowData: any = {}; // Initialize with selected property
          
          // Loop through the headers to populate rowData
          this.headers.forEach((header, colIndex) => {
            if (header) {
              rowData[header] = row[colIndex];
            }
          });
                  
          // Add deviceId and deviceCategoryId to the rowData object
          rowData.deviceId = this.deviceId;
          rowData.deviceCategoryId = this.deviceCategoryId;

          return rowData;
        });
       
     
    };
  
    reader.readAsBinaryString(target.files[0]);
  }
  
  OnSubmit() {
    this.isLoading = true;
    this.changeService.loader(true);
    // Filter selected rows
    //const selectedData = this.data.filter(row => row.selected);
    
    const selectedData = this.data
        .map(row => {
          // Check if 'colName' is missing or undefined, and if so, set it to an empty string
          if (!row.hasOwnProperty('colName') || row.colName === undefined) {
            row.colName = "";
          }
          return row;
        });

    //Post selected data to the backend
    this.dataService.postData(this.EnergymeterBaseUrl+"/device-modbus-mapping/"+this.deviceId, selectedData)
      .then(res => {
        this.isLoading = false;
        this.changeService.loader(false);
        if (JSON.parse(JSON.stringify(res)).data.status === 'fail') {
          const msgErr = JSON.parse(JSON.stringify(res)).data.body.message;
          this.dataService.showError(msgErr);
        } else if (JSON.parse(JSON.stringify(res)).data.status === 'success') {
          this.dataService.showSuccess('Device modbus mapping process successfully');
          this.router.navigate(['view-device-type']);
        } else {
          this.dataService.showError('Something went wrong.');
        }
        
      })
      .catch(error => {
        console.error('Error processing data:', error);
      });
  }

  OnUpdate() {
    
    const updatedRows = this.editObj;

    if (updatedRows.length > 0) {

        this.isLoading=true;
        
        //Post selected data to the backend
        this.dataService.postData(this.EnergymeterBaseUrl+"/device-modbus-mapping/"+this.deviceId, updatedRows)
          .then(res => {

            this.isLoading=false;
            this.changeService.loader(false);
            if (JSON.parse(JSON.stringify(res)).data.status === 'fail') {
              const msgErr = JSON.parse(JSON.stringify(res)).data.body.message;
              this.dataService.showError(msgErr);
            } else if (JSON.parse(JSON.stringify(res)).data.status === 'success') {
              this.dataService.showSuccess('Device modbus mapping process successfully');
              this.router.navigate(['view-device-type']);
            } else {
              this.dataService.showError('Something went wrong.');
            }
            
          })
          .catch(error => {
            console.error('Error processing data:', error);
          });

    } else {
      this.dataService.showError('No rows selected for updating.');     
    }
  }

  cancelBtn(){
    this.location.back();
  }


  // onChecked(event: any) {
  //   const isChecked = event.target.checked; // Get the checked state of the checkbox

  //   // Update the `selected` property for all rows in `this.data`

  //   if(this.formTitle==='Addform'){

  //     this.data.forEach(row => {
  //       row.selected = isChecked;
  //     });

  //   }else{

  //     this.editObj.forEach(row => {
  //       row.selected = isChecked;
  //     });
  //   }


    

  //   console.log('Checkbox is', isChecked ? 'checked' : 'unchecked', this.data);
  // }
}
